import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react';

import Notification from '../components/notification/notification.component';

const DISPLAY_MS = 4000;

export const NotificationContext = createContext({ notify: () => {} });

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);
  const timeoutRef = useRef(null);

  const dismiss = useCallback(() => {
    clearTimeout(timeoutRef.current);
    setNotification(null);
  }, []);

  // Un seul message à l'écran : le suivant remplace le précédent et relance le
  // compte à rebours, plutôt que d'empiler des encarts qui se recouvrent.
  const notify = useCallback((message, type = 'success') => {
    clearTimeout(timeoutRef.current);
    // L'horodatage sert de clé : deux fois le même message doit rejouer l'entrée.
    setNotification({ message, type, id: Date.now() });
    timeoutRef.current = setTimeout(() => setNotification(null), DISPLAY_MS);
  }, []);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      <Notification
        key={notification?.id}
        notification={notification}
        onDismiss={dismiss}
      />
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
